import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import ReportsDataGrid from 'Pages/reports/components/ReportsDataGrid/ReportsDataGrid';
import { ReportsButtonGroup } from 'Pages/reports/components/ReportsButtonGroup/ReportsButtonGroup';
import { buildTime } from 'Pages/reports/utils/buildTime';
import { toReportsPagination } from 'Pages/reports/utils/pagination';
import { CoursesReportIcon, EmployeesReportIcon } from 'Pages/reports/components/icons';
import { useHistoryCoursesReportPage } from './hooks/useHistoryCoursesReportPage';
import { Padding } from 'Components/Padding';
import HistoryCoursesFilters from './components/HistoryCoursesFilters/HistoryCoursesFilters';
import ActionButtons from './components/ActionButtons';
import MassiveExportDialog from './components/MassiveExportDialog';
import type { GridColDef } from '@mui/x-data-grid';

interface Row {
  id: string;
  name: string;
  priority: string;
  category: string;
  totalTrainingHours: string;
}

export default function Page() {
  const {
    historyCoursesData,
    historyCoursesPagination,
    historyCoursesLoading,
    historyCoursesError,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
    handleRowClick,

    isMassiveDialogOpen,
    setIsMassiveDialogOpen,
  } = useHistoryCoursesReportPage();

  const buttons = [
    {
      icon: <EmployeesReportIcon />,
      tooltip: t2('employees_report_tooltip'),
      route: '/reporte/historial/empleados',
    },
    { icon: <CoursesReportIcon />, tooltip: t2('courses_report_tooltip'), route: '/reporte/historial/cursos' },
  ];

  const columns: GridColDef[] = [
    { field: 'name', headerName: t2('course_name'), flex: 1.5 },
    { field: 'priority', headerName: t2('priority'), flex: 1 },
    { field: 'category', headerName: t2('category'), flex: 1 },
    {
      field: 'totalTrainingHours',
      headerName: t2('total_completions'),
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  const rows: Row[] = historyCoursesData.map(item => ({
    id: item.id,
    name: item.name,
    priority: item.priority?.name || '-',
    category: item.category?.name || '-',
    totalTrainingHours: buildTime(parseFloat(item.totalTrainingHours || '0'), t2),
  }));

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={<ReportsButtonGroup buttons={buttons} />}
        actions={<ActionButtons onExport={handleExport} onMassiveExport={() => setIsMassiveDialogOpen(true)} />}
      />
      <Padding padding="1rem">
        <HistoryCoursesFilters onSearch={handleSearch} />
        <Padding padding="0.5rem 0" />
        <ReportsDataGrid<Row>
          columns={columns}
          rows={rows}
          loading={historyCoursesLoading}
          error={historyCoursesError}
          pagination={toReportsPagination(historyCoursesPagination)}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRowClick={row => handleRowClick(row)}
        />
      </Padding>
      <MassiveExportDialog open={isMassiveDialogOpen} onClose={() => setIsMassiveDialogOpen(false)} />
    </SideBarContainer>
  );
}
